import React from 'react'

const PalettteAppLogo = props => {
  return (
    <g fill="none" fillRule="evenodd">
      <rect
        fill="#004469"
        height="81.914396"
        rx="40.957198"
        width="81.914396"
        x="19.019978"
        y="19.019978"
      />
      <g transform="translate(49.909074 29.412176)">
        <path
          d="m13.602586 55.4977677-6.80920734 2.7933667v-52.68894331l6.80920734-2.79336669z"
          fill="#0085ce"
        />
        <path
          d="m6.8715398 58.2589977-6.80920739 2.7933667v-52.68887095l6.80920739-2.79336669z"
          fill="#006399"
        />
        <path
          d="m20.3735717 52.7200808-6.8093746 2.7934353v-52.68894328l6.8093746-2.79343529z"
          fill="#00a4ff"
        />
      </g>
    </g>
  )
}

export default PalettteAppLogo
